module.exports = __webpack_public_path__ + "static/fipcpastelfloralmain-a1456f8c3b0f4e687ecb7d7e4dcee87c.jpeg";